import { useBaseFileMutation } from "@mutation/baseMutation";

export const useFileUploadMutation = () => {
    return useBaseFileMutation( { endpoint: "/file/", method: "POST" } );
};

export const useFileDeleteMutation = () => {
    return useBaseFileMutation( { endpoint: `/file/{file_uuid}`, method: "DELETE" } );
};